import { getDatesWithEstimationsGallery } from "@/service/estimation.service";

export const getMarkedDatesGallery = async (
  samplingPoint: number[],
  dateKey: number
): Promise<{ datesWithEstimations: string[]; dateKey: number } | undefined> => {
  let datesWithEstimations = [] as string[];
  await getDatesWithEstimationsGallery(samplingPoint).then((response) => {
    datesWithEstimations = response.map((_) => new Date(_.image_date).toDateString());
    // - reload daate picker
    dateKey++;
  });
  return { datesWithEstimations, dateKey };
};
